export const displayKeys = ['display'];
